import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Modal,
  ButtonToolbar,
  Dropdown,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { ReportIssueTable } from "./ReportIssueTable";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  checkPermision,
  formLabelsTheme,
  getValueType,
  iconError,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  useForceUpdate,
  useStyles,
  useStylesReddit,
} from "../../utility";
import SVG from "react-inlinesvg";
import Select from "react-select";
import {
  sortCaret,
  headerSortingClasses,
  toAbsoluteUrl,
} from "../../../_metronic/_helpers";
import {
  selectPagination,
  selectUser,
} from "../../modules/Auth/_redux/authRedux";

// MUI
import {
  fade,
  withStyles,
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { red } from "@material-ui/core/colors";
// import { UserCreate } from "./UserCreate";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import {
  fetchGroupCountry,
  fetchGroupPhoneType,
  fetchParameter,
  fetchParameter2,
  fetchParameter3,
  fetchParameter4,
} from "../businessParameter/businessParameterSlice";

import {
  resetData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchReportIssue,
  selectReportIssue,
  addReportIssueUpload,
  fetchFile,
  fetchFileBlob,
  addReportIssueUploadResolve,
} from "./reportIssueSlice";
import { fetchClient } from "../client/clientSlice";
import { ModalClientRadio } from "../report/ModalClientRadio";
import { FormHelperText } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { ModalCreateReportIssue } from "./ModalCreateReportIssue";
import {
  addMasterUpload,
  fetchMasterUpload,
  fetchReasonCode,
  prosesUpload,
  selectMasterUpload,
  selectReasonCode,
} from "../miscellaneous/MiscellaneousSlice";
import {
  fetchFileTemplate,
  fetchFileTemplateBlob,
} from "../inbound/inboundSlice";
import BootstrapTable from "react-bootstrap-table-next";

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

export const ReportIssueUploadTab = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const paginationSet = useSelector(selectPagination);
  const forceUpdate = useForceUpdate();
  const dataReason = useSelector(selectReasonCode);
  const data = useSelector(selectMasterUpload);

  // Filter
  const [value, setValue] = useState(0);
  const [force, setForce] = useState(false);

  // initial
  const [fileName, setFileName] = useState("Upload Template File");
  const [title, setTitle] = useState("");
  const [file, setFile] = useState(null);
  const [show, setShow] = useState(null);
  const [formValues, setFormValues] = useState({
    client_name: {
      value: "",
      error: false,
      required: "Y",
    },
    vin: {
      value: "",
      error: false,
      required: "N",
    },
    hold_reason: {
      value: "",
      error: false,
      required: "N",
    },
    hold_remark: {
      value: "",
      error: false,
      required: "N",
    },
    issue_date: {
      value: "",
      error: false,
      required: "N",
    },
    inspection_status: {
      value: "",
      error: false,
      required: "N",
    },
    issuer: {
      value: "",
      error: false,
      required: "N",
    },
    resolution_date: {
      value: "",
      error: false,
      required: "N",
    },
    resolution_remark: {
      value: "",
      error: false,
      required: "N",
    },
    resolver: {
      value: "",
      error: false,
      required: "N",
    },
  });

  useEffect(() => {
    // Add number
    const initData =
      data === null
        ? []
        : data.map((item, index) => {
            return {
              ...item,
              no: index + 1,
            };
          });
    setTableData(initData);
  }, [data]);

  const [tableData, setTableData] = useState(data);

  const handleSelect = async (e) => {
    console.log(e, "e");
    if (e === "Upload Issue") {
      setTitle("Upload Issue");
      setShow(true);
    } else {
      setTitle("Upload Resolve");
      setShow(true);
    }
  };

  const handleClose = () => {
    setFileName("Upload Template File ");
    setFile(null);
    setShow(false);
  };

  const handleDownload = async () => {
    const params = {
      id: "",
      type: title === "Upload Issue" ? "REPORT_ISSUE" : "RESOLVE_ISSUE",
    };
    try {
      const response = await dispatch(fetchFileTemplate(params));
      if (response.payload.status === 200) {
        const response = await dispatch(fetchFileTemplateBlob(params));
        if (response.payload.status === 200) {
          const blob = new Blob([response.payload.data], {
            type: "application/xlsx",
          });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `${title}.xlsx`;
          link.click();
        }
      } else {
        showErrorDialog(response.payload.data.message);
        console.log("else");
      }
    } catch (error) {
      console.log("catch");
      showErrorDialog(error.message);
    }
  };

  const handleUpload = async () => {
    if (file == null) {
      return showErrorDialog("Please Input");
    }

    if (title === "Upload Issue") {
      const params = {
        id: title === "Upload Issue" ? "REPORT_ISSUE" : "RESOLVE_ISSUE",
        file: file,
      };
      try {
        const response = await dispatch(addReportIssueUpload(params));
        console.log(response, "response");
        if (response.payload.status === 200) {
          // const action = await showSuccessDialog(response.payload.data.message);
          const id = response.payload.data.data.misc_header_id;
          const params = {
            misc_header_id: id,
          };
          try {
            const response = await dispatch(prosesUpload(params));

            console.log(response, "response");

            if (response.payload.status === 200) {
              const action = await showSuccessDialog(
                response.payload.data.message
              );
              await dispatch(
                fetchMasterUpload({
                  file_type: "REPORT_ISSUE,RESOLVE_ISSUE",
                  pageNo: 1,
                  pageSize: 10,
                })
              );
              await handleClose();
            } else {
              await showErrorDialog(response.payload.data.message);
            }
          } catch (error) {
            showErrorDialog(error.message);
          }
        } else {
          await showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      const params = {
        id: title === "Upload Issue" ? "REPORT_ISSUE" : "RESOLVE_ISSUE",
        file: file,
      };
      try {
        const response = await dispatch(addReportIssueUploadResolve(params));
        console.log(response, "response");
        if (response.payload.status === 200) {
          // const action = await showSuccessDialog(response.payload.data.message);
          const id = response.payload.data.data.misc_header_id;
          const params = {
            misc_header_id: id,
          };
          try {
            const response = await dispatch(prosesUpload(params));

            console.log(response, "response");

            if (response.payload.status === 200) {
              const action = await showSuccessDialog(
                response.payload.data.message
              );
              await dispatch(
                fetchMasterUpload({
                  file_type: "REPORT_ISSUE,RESOLVE_ISSUE",
                  pageNo: 1,
                  pageSize: 10,
                })
              );
              await handleClose();
            } else {
              await showErrorDialog(response.payload.data.message);
            }
          } catch (error) {
            showErrorDialog(error.message);
          }
        } else {
          await showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    }
  };

  const handleDownloadFile = async (row) => {
    console.log(row, "row");
    const params = {
      id: row.misc_header_id,
    };
    try {
      const response = await dispatch(fetchFile(params));
      if (response.payload.status === 200) {
        const response = await dispatch(fetchFileBlob(params));
        if (response.payload.status === 200) {
          const blob = new Blob([response.payload.data], {
            type: "application/xlsx",
          });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `${row.file_name}.xlsx`;
          link.click();
        }
      } else {
        showErrorDialog(response.payload.data.message);
        console.log("else");
      }
    } catch (error) {
      console.log("catch");
      showErrorDialog(error.message);
    }
  };

  const actionFileFormatter = (e, row, rowIndex) => {
    return (
      <>
        <div>
          {row.status === "Completed" && (
            <OverlayTrigger
              overlay={<Tooltip id="products-edit-tooltip">Download</Tooltip>}
            >
              <div
                className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                onClick={() => {
                  handleDownloadFile(row);
                }}
              >
                <span className="svg-icon svg-icon-md svg-icon-light">
                  <span className="svg-icon svg-icon-md svg-icon-light">
                    <SVG
                      src={toAbsoluteUrl("/media/svg/icons/New/Download.svg")}
                    />
                  </span>
                </span>
              </div>
            </OverlayTrigger>
          )}
        </div>
      </>
    );
  };

  const columnsFile = [
    {
      text: "Uploaded File",
      dataField: "file_name",
    },
    {
      text: "Status",
      dataField: "status",
    },
    {
      text: "Action",
      dataField: "Action",
      formatter: actionFileFormatter,
    },
  ];

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <div>
        <Card>
          <CardBody>
            <div className="topbar-item-select ">
              <Dropdown onSelect={handleSelect}>
                <Dropdown.Toggle
                  className="my-btn-primary-dark"
                  id="dropdown-basic"
                >
                  Upload
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item eventKey="Upload Issue">
                    Upload Issue
                  </Dropdown.Item>
                  <Dropdown.Item eventKey="Upload Resolution">
                    Upload Resolution
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>

            <div className="mb-3">
              <p className="font-weight-boldest">File Upload Progress</p>
              <Row>
                <Col md={8}>
                  <BootstrapTable
                    wrapperClasses="table-responsive"
                    classes="table table-head-custom table-vertical-center overflow-hidden"
                    bootstrap4
                    
                    keyField="no"
                    data={tableData}
                    columns={columnsFile}
                    hover
                  />
                </Col>
              </Row>
            </div>
          </CardBody>
        </Card>
      </div>

      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter text-white">
            {title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-5">
            <h5 className="font-weight-boldest">File</h5>

            <Row>
              <Col xs={12} sm={3} md={6} lg={6}>
                <Form.File
                  type="file"
                  id="file_fpre"
                  custom
                  label={fileName}
                  onChange={(e) => {
                    setFile(e.target.files[0]);
                    setFileName(e.target.files[0].name);
                  }}
                  accept=".xlsx, .XLSX"
                />
              </Col>
              <Col>
                <Button variant="primary" onClick={handleUpload}>
                  Upload
                </Button>
              </Col>
            </Row>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-primary" onClick={handleDownload}>
            Download Template
          </Button>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
